"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUrl = exports.parseHostname = void 0;
/// For anything related to regex parsing.
/**
 * Returns domain name from url string
 * @param url The http or https string
 * @returns https://api.thegraph.com/subgraphs/name... => api.thegraph.com
 */
const parseHostname = (url) => {
    const matches = /^https?:\/\/([^/?#]+)(?:[/?#]|$)/i.exec(url);
    return matches && matches[1];
};
exports.parseHostname = parseHostname;
const formatUrl = (_url, endpoint, identifier) => {
    let url = `${_url}/${endpoint}`;
    if (identifier) {
        url += `${identifier}`;
    }
    return url;
};
exports.formatUrl = formatUrl;
//# sourceMappingURL=parse.js.map